import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/service/auth';
import {BasicService} from 'src/service/basic.service';
import { Router } from "@angular/router";
import {MatRadioModule} from '@angular/material/radio';
import { FormBuilder, FormGroup , Validators } from '@angular/forms';
import { BRAND_ASSETS } from '../constants/branding';

@Component({
  selector: 'app-signup',
  templateUrl: './signup.component.html',
  styleUrls: ['./signup.component.scss']
})
export class SignupComponent implements OnInit {
  brand = BRAND_ASSETS;

  
  signUpForm:FormGroup;

  constructor(private fb:FormBuilder,private MatRadioModule : MatRadioModule, private authService: AuthService,private basicService:BasicService, private router: Router) { 
    this.signUpForm= fb.group({
      name:[null,[Validators.required,this.basicService.isEmpty]],
      email:[null,[Validators.required,this.basicService.isEmail]],
      organization:[null,[Validators.required,this.basicService.isEmpty]],
      businessModel:["owner",[]],
      country:["india",[]],
      phone:[null,[Validators.required,this.basicService.isPhone]],
    })
  }


  errorMsg:any = null;
  successMsg:any = null;
  success:any = null;

  ngOnInit(): void {
  }

  onSubmit = () =>{
    if (this.signUpForm.valid) {
      let data={
        name:this.signUpForm.controls["name"].value,
        email:this.signUpForm.controls["email"].value,
        organization:this.signUpForm.controls["organization"].value,
        businessModel:this.signUpForm.controls["businessModel"].value,
        country:this.signUpForm.controls["country"].value,
        phone:this.signUpForm.controls["phone"].value
      }
      this.basicService.showprogress=true;
      this.authService.signup(data).toPromise().then((response: any) => {
        this.basicService.showprogress=false;
        if(response.status=="success"){
          this.router.navigate(['/login']);
        }else{
          this.errorMsg = response.message;
        }
        
      })
    }else{
      for (const x in this.signUpForm.controls) {
        if (this.signUpForm.controls.hasOwnProperty(x)) {
            this.signUpForm.controls[x].markAsTouched()
        }
      }
    }  
  }
  countryChangeFun(event:any){

  }
}
